import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { QUERY_KEYS } from "../../app/data/common/queryKeys";
import NotificationService from "../../app/data/notifications/notificationService";
import { useSelector } from "react-redux";
import { userSelector } from "../../slices/user/userSlice";

export const useNotifications = () => {
  const userState = useSelector(userSelector);
  const queryClient = useQueryClient();
  const email = userState.profile?.email;

  const {
    data: notifications,
    isLoading,
    error,
    refetch
  } = useQuery({
    queryKey: [QUERY_KEYS.NOTIFICATIONS, email],
    queryFn: () => NotificationService.getInstance().getRecentNotifications(email!),
    enabled: !!email,
    refetchInterval: 30000, // Refetch every 30 seconds
    refetchOnWindowFocus: true,
    staleTime: 10000, // Consider data stale after 10 seconds
  });

  const markAsReadMutation = useMutation({
    mutationFn: (deliveryId: string) => NotificationService.getInstance().markNotificationAsRead(deliveryId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.NOTIFICATIONS, email] });
    },
  });

  const markAllAsReadMutation = useMutation({
    mutationFn: () => NotificationService.getInstance().markAllNotificationsAsRead(email!),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.NOTIFICATIONS, email] });
    },
  });

  const unreadCount = notifications?.filter(notification => !notification.read).length || 0;

  return {
    notifications: notifications || [],
    isLoading,
    error,
    unreadCount,
    markAsRead: markAsReadMutation.mutate,
    markAllAsRead: markAllAsReadMutation.mutate,
    refetch,
  };
};
